export const is_all_same_aspect_ratio = (imgs: HTMLImageElement[]): boolean => {
  if (!imgs.length || imgs.length === 1) return true

  const ratio = imgs[0].naturalWidth / imgs[0].naturalHeight

  for (let i = 1; i < imgs.length; i++) {
    const this_ratio = imgs[i].naturalWidth / imgs[i].naturalHeight
    if (ratio != this_ratio) return false
  }

  return true
}

export const fitDimensionsToNodeWidth = (
  width: number,
  height: number,
  nodeWidth: number,
  minHeight: number = 64
): { minHeight: number; minWidth: number } => {
  const intrinsicAspectRatio = width / height
  if (!intrinsicAspectRatio || isNaN(intrinsicAspectRatio))
    return { minHeight: 0, minWidth: 0 }

  // Set min. height s.t. image spans node's x-axis while maintaining aspect ratio
  const minWidth = nodeWidth
  const calculatedHeight = Math.max(minWidth / intrinsicAspectRatio, minHeight)

  return { minHeight: calculatedHeight, minWidth }
}

/**
 * 为图片URL添加优化后缀
 * @param url 图片URL
 * @param width 目标宽度，默认300
 * @returns 添加了优化后缀的URL
 */
export const optimizeImageUrl = (
  url: string | null | undefined,
  width: number = 300
): string => {
  if (!url) return ''
  // 如果URL中已经包含x-image-process参数，直接返回
  if (url.includes('x-image-process=')) {
    return url
  }
  // 如果URL中已经包含参数，使用&连接，否则使用?
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}x-image-process=image/resize,w_${width}`
}
